import { render, staticRenderFns } from "./TermsFilterDefaultLayout.vue?vue&type=template&id=16eaa0bf&scoped=true&"
import script from "./TermsFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./TermsFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16eaa0bf",
  null
  
)

export default component.exports